import Home from "../views/Home";
import Login from "../views/Login";
import Insights from "@/views/Insights";
import Notifications from "@/views/Notifications";
import NotificationsBuilder from "../views/NotificationsBuilder";
import Advertising from "@/views/Advertising";
import NotificationsReporting from "@/views/NotificationsReporting";
import NotificationsSegments from "@/views/NotificationsSegments";
import AdvertisingEstimator from "@/views/AdvertisingEstimator";
import AdvertisingSegments from "@/views/AdvertisingSegments";
import InsightsGDSTrendsOverTime from "@/views/InsightsGDSTrendsOverTime";
import InsightsGDSWeeklyDetail from "@/views/InsightsGDSWeeklyDetail";

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '/insights',
        name: 'Insights',
        redirect: '/insights/trendsovertime',
        component: Insights,
        children: [
          {
            path: "/insights/weeklydetail",
            name: "InsightsGDSWeeklyDetail",
            component: InsightsGDSWeeklyDetail
          },
          {
            path: "/insights/trendsovertime",
            name: "InsightsGDSTrendsOverTime",
            component: InsightsGDSTrendsOverTime
          },
        ]
      },
      {
        path: '/notifications',
        name: 'Notifications',
        component: Notifications,
        children: [
          {
            path: '/notifications/builder',
            name: 'NotificationsBuilder',
            component: NotificationsBuilder,
            meta: {
              includeBrandSelect: true
            },
          },
          {
            path: '/notifications/reporting',
            name: 'NotificationsReporting',
            component: NotificationsReporting,
            meta: {
              includeBrandSelect: true
            },
          },
          {
            path: '/notifications/segments',
            name: 'NotificationsSegments',
            component: NotificationsSegments,
            meta: {
              includeBrandSelect: false
            },
          },
        ]
      },
      {
        path: '/advertising',
        name: 'Advertising',
        component: Advertising,
        children: [
          {
            path: '/advertising/estimator',
            name: 'AdvertisingEstimator',
            component: AdvertisingEstimator
          },
          {
            path: '/advertising/segments',
            name: 'AdvertisingSegments',
            component: AdvertisingSegments
          },
        ]
      },
    ]
  }
];

export default routes;